export enum InvoiceStatus {
  delayed = 'delayed',
  pending = 'pending',
  paid = 'paid',
  canceled = 'canceled',
}

export namespace InvoiceStatus {
  export const translateStatus = (type: InvoiceStatus): string => {
    switch (type) {
      case InvoiceStatus.delayed:
        return "Atrasado";
      case InvoiceStatus.pending:
        return "Pendente";
      case InvoiceStatus.paid:
        return "Pago";
      case InvoiceStatus.canceled:
        return "Cancelado";
      default:
        return "";
    }
  };

  export const InvoiceStatusChoices = Object.values(InvoiceStatus).filter(x => typeof x === "string")
  .map(status => {
    return ({
      id: status,
      name: InvoiceStatus.translateStatus(status)
    });
  });
}